import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { groupAreasByProject } from "../../../../utils/groupAreasByProject";
import {
  PageList,
  ProjectSection,
  ProjectHeader,
  ProjectTitle,
  ProjectMeta,
  ProjectLink,
  CardsGrid,
  CardContainer,
  Title,
  Info,
  InnerContainer,
  CardImage,
  EmptyMessage,
} from "./styles";

const AreaCard = ({ filteredAreas }) => {
  const users = useSelector((state) => state.app_data.users);
  const navigate = useNavigate();

  const groups = useMemo(
    () => groupAreasByProject(filteredAreas),
    [filteredAreas]
  );

  const getResponsibleName = (responsibleId) => {
    if (!Array.isArray(users)) return "—";
    const user = users.find((u) => u.id === responsibleId);
    return user ? user.full_name : "—";
  };

  if (!filteredAreas || filteredAreas.length === 0) {
    return <EmptyMessage>Nenhuma área cadastrada.</EmptyMessage>;
  }

  return (
    <PageList>
      {groups.map((group) => (
        <ProjectSection key={String(group.projectId)}>
          <ProjectHeader>
            <div>
              <ProjectTitle>{group.projectTitle}</ProjectTitle>
              <ProjectMeta>
                {group.areas.length}{" "}
                {group.areas.length === 1 ? "área" : "áreas"}
              </ProjectMeta>
            </div>
            {group.projectId !== "none" ? (
              <ProjectLink
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/intern_project/${group.projectId}`);
                }}
              >
                Ver projeto
              </ProjectLink>
            ) : null}
          </ProjectHeader>

          <CardsGrid>
            {group.areas.map((area, index) => (
              <CardContainer
                key={area.id_code || `${group.projectId}-${index}`}
                onClick={() => navigate(`/area_details/${area.id_code}`)}
                type="button"
              >
                {area.adi_image ? (
                  <CardImage
                    src={area.adi_image}
                    alt={area.name || "Área sem nome"}
                  />
                ) : null}

                <InnerContainer>
                  <Title>{area.name || "Sem Nome"}</Title>
                  <Info>
                    Gestor:{" "}
                    {area.adi_responsible_name ||
                      getResponsibleName(area.adi_responsible)}
                  </Info>
                </InnerContainer>
              </CardContainer>
            ))}
          </CardsGrid>
        </ProjectSection>
      ))}
    </PageList>
  );
};

export default AreaCard;
